import React from 'react';
import { FaGavel, FaHandshake, FaExclamationCircle } from 'react-icons/fa';

export const Terms = () => {
  return (
    <div className="p-8 mt-16 max-w-4xl mx-auto bg-white rounded-lg shadow-lg">
      <h1 className="text-4xl font-extrabold mb-6 text-center text-gray-800">Terms of Service</h1>
      <p className="text-lg text-gray-700 mb-6 text-center">Our terms of service outline the rules and regulations for using our website and services.</p>

      <div className="space-y-8">
        <div className="flex items-center space-x-4">
          <FaGavel className="text-green-500 w-8 h-8" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Acceptance of Terms</h2>
            <p className="text-gray-600">By accessing or using our services, you agree to be bound by these terms and conditions. If you do not agree with any part of the terms, you must not use our services.</p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <FaHandshake className="text-green-500 w-8 h-8" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800">User Responsibilities</h2>
            <p className="text-gray-600">Users must use our services in a lawful manner and are prohibited from using the site for any unlawful or prohibited activities.</p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <FaExclamationCircle className="text-green-500 w-8 h-8" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Limitation of Liability</h2>
            <p className="text-gray-600">We are not liable for any damages that may occur from using our services. This includes, but is not limited to, direct, indirect, incidental, punitive, and consequential damages.</p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <FaGavel className="text-green-500 w-8 h-8" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Modification of Terms</h2>
            <p className="text-gray-600">We reserve the right to modify these terms at any time. Your continued use of the site following any changes indicates your acceptance of the new terms.</p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <FaHandshake className="text-green-500 w-8 h-8" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Governing Law</h2>
            <p className="text-gray-600">These terms are governed by the laws of the jurisdiction where our company is based. Any disputes arising from these terms will be resolved in the courts of that jurisdiction.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
